import { REQUEST, FAILURE, SUCCESS } from 'redux-config/reduxHelpers';
import * as ActionTypes from './actions';

export const initialState = {
  depositSystems: [],
  loadingDepositSystems: true,

  withdrawalSystems: [],
  loadingWithdrawalSystems: true,

  paymentsInfo: null,
  loadingPayments: false,
  paymentInfoIsLoaded: false,

  paymentsList: {},
  loadingPaymentsList: false,

  inOutList: {},
  inOutListIsLoaded: false,

  userEditHistory: [],
  userEditHistoryIsLoaded: false,

  paymentForm: null,
  paymentFormIsLoaded: null,

  paymentProofUploaded: false,
  paymentProofUploadError: null,

  availableLpas: [],
  availableLpasAreLoaded: false,

  lpaAgentDeals: {},
  lpaAgentDealsIsLoaded: false,

  lpaClientDeals: {},
  lpaClientDealsIsLoaded: false,

  lpaDeal: {},
  lpaDealIsLoaded: false,

  isConfirmationMessageResent: null,
  confirmationMessageIsSending: false,

  exchangeRate: {},
  exchangeRateIsLoaded: false,
  exchangeRateError: null,

  pendingEvents: [],

  depositRequisites: [],
  depositRequisitesLoaded: false,

  withdrawRequisites: [],
  withdrawRequisitesLoaded: false,

  confirmationForm: null,
  confirmationFormIsLoaded: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.GET_DEPOSIT_SYSTEM_LIST[REQUEST]:
      return { ...state, paymentForm: null, paymentFormIsLoaded: null, loadingDepositSystems: true };
    case ActionTypes.GET_DEPOSIT_SYSTEM_LIST[SUCCESS]:
      return {
        ...state,
        loadingDepositSystems: false,
        depositSystems: action.systems,
      };
    case ActionTypes.GET_DEPOSIT_SYSTEM_LIST[FAILURE]:
      return { ...state, loadingDepositSystems: false };

    case ActionTypes.GET_WITHDRAWAL_SYSTEM_LIST[REQUEST]:
      return { ...state, paymentForm: null, paymentFormIsLoaded: null, loadingWithdrawalSystems: true };
    case ActionTypes.GET_WITHDRAWAL_SYSTEM_LIST[SUCCESS]:
      return {
        ...state,
        loadingWithdrawalSystems: false,
        withdrawalSystems: action.systems,
      };
    case ActionTypes.GET_WITHDRAWAL_SYSTEM_LIST[FAILURE]:
      return { ...state, loadingWithdrawalSystems: false };

    case ActionTypes.GET_PAYMENTS[REQUEST]:
      return { ...state, loadingPayments: true, paymentInfoIsLoaded: false, pendingEvents: [] };
    case ActionTypes.GET_PAYMENTS[SUCCESS]: {
      const updatedPaymentInfo = /* for tests */ (state.pendingEvents.findLast &&
        state.pendingEvents.findLast(event => event.id === action.info.id)) || {
        cancelButton: action.info.cancelButton,
        paymentProofStatus: action.info.paymentProofStatus,
        comment: action.info.comment,
        amount: action.info.amount,
        commission: action.info.commission,
        amountWithCommission: action.info.amountWithCommission,
      };
      return {
        ...state,
        loadingPayments: false,
        paymentInfoIsLoaded: true,
        pendingEvents: [],
        paymentsInfo: {
          type: action.operationType,
          ...action.info,
          ...updatedPaymentInfo,
          events: [
            ...action.info.events.map(event => ({
              id: event.id,
              status: event.change,
              updated: event.at,
              newEvent: false,
            })),
            ...state.pendingEvents.filter(event => event.id === action.info.id),
          ],
        },
      };
    }
    case ActionTypes.GET_PAYMENTS[FAILURE]:
      return { ...state, loadingPayments: false, paymentInfoIsLoaded: false };

    case ActionTypes.GET_PAYMENTS_LIST[REQUEST]:
      return { ...state, loadingPaymentsList: false };
    case ActionTypes.GET_PAYMENTS_LIST[SUCCESS]:
      return {
        ...state,
        loadingPaymentsList: true,
        paymentsList: action.data,
      };
    case ActionTypes.GET_PAYMENTS_LIST[FAILURE]:
      return { ...state, loadingPaymentsList: false };

    case ActionTypes.GET_IN_OUT_LIST[REQUEST]:
      return { ...state, inOutListIsLoaded: false };
    case ActionTypes.GET_IN_OUT_LIST[SUCCESS]:
      return {
        ...state,
        inOutListIsLoaded: true,
        inOutList: action.data,
      };
    case ActionTypes.GET_IN_OUT_LIST[FAILURE]:
      return { ...state, inOutListIsLoaded: false };

    case ActionTypes.USER_GET_EDIT_HISTORY[REQUEST]:
      return { ...state, userEditHistoryIsLoaded: false };
    case ActionTypes.USER_GET_EDIT_HISTORY[SUCCESS]:
      return { ...state, userEditHistory: action.data, userEditHistoryIsLoaded: true };
    case ActionTypes.USER_GET_EDIT_HISTORY[FAILURE]:
      return { ...state, error: action.error, userEditHistoryIsLoaded: false };

    case ActionTypes.makeDeposit[REQUEST]:
      return {
        ...state,
        paymentFormIsLoaded: null,
      };
    case ActionTypes.makeDeposit[SUCCESS]:
      return {
        ...state,
        paymentForm: action.payload,
        paymentFormIsLoaded: true,
      };
    case ActionTypes.makeDeposit[FAILURE]:
      return {
        ...state,
        error: action.error,
        paymentFormIsLoaded: false,
      };

    case ActionTypes.makeWithdraw[REQUEST]:
      return { ...state, paymentFormIsLoaded: null };
    case ActionTypes.makeWithdraw[SUCCESS]:
      return { ...state, paymentForm: action.payload, paymentFormIsLoaded: true };
    case ActionTypes.makeWithdraw[FAILURE]:
      return { ...state, error: action.error, paymentFormIsLoaded: false };

    case ActionTypes.RESEND_PAYMENT_CONFIRMATION_MESSAGE[REQUEST]:
      return { ...state, isConfirmationMessageResent: null, confirmationMessageIsSending: true };
    case ActionTypes.RESEND_PAYMENT_CONFIRMATION_MESSAGE[SUCCESS]:
      return { ...state, isConfirmationMessageResent: true, confirmationMessageIsSending: false };
    case ActionTypes.RESEND_PAYMENT_CONFIRMATION_MESSAGE[FAILURE]:
      return { ...state, error: action.error, isConfirmationMessageResent: false, confirmationMessageIsSending: false };

    case ActionTypes.resetPaymentForm[REQUEST]:
      return { ...state, paymentForm: null, paymentFormIsLoaded: null };
    case ActionTypes.resetPaymentForm[SUCCESS]:
      return { ...state, paymentFormIsLoaded: true };
    case ActionTypes.resetPaymentForm[FAILURE]:
      return { ...state, paymentForm: null, error: action.error, paymentFormIsLoaded: false };

    case ActionTypes.UPLOD_PAYMENT_PROOF[REQUEST]:
      return { ...state, paymentProofUploadError: null, paymentProofUploaded: false };
    case ActionTypes.UPLOD_PAYMENT_PROOF[SUCCESS]: {
      return {
        ...state,
        paymentProofUploaded: true,
        paymentProofUploadError: null,
      };
    }
    case ActionTypes.UPLOD_PAYMENT_PROOF[FAILURE]:
      return {
        ...state,
        paymentProofUploaded: false,
        paymentProofUploadError: action.error,
      };

    case ActionTypes.GET_AVAILABLE_LPAS[REQUEST]:
      return { ...state, availableLpasAreLoaded: false };
    case ActionTypes.GET_AVAILABLE_LPAS[SUCCESS]:
      return { ...state, availableLpas: action.data, availableLpasAreLoaded: true };
    case ActionTypes.GET_AVAILABLE_LPAS[FAILURE]:
      return { ...state, error: action.error, availableLpasAreLoaded: false };

    case ActionTypes.GET_LPA_AGENT_DEALS[REQUEST]:
      return { ...state, lpaAgentDealsIsLoaded: false };
    case ActionTypes.GET_LPA_AGENT_DEALS[SUCCESS]:
      return {
        ...state,
        lpaAgentDealsIsLoaded: true,
        lpaAgentDeals: action.data,
      };
    case ActionTypes.GET_LPA_AGENT_DEALS[FAILURE]:
      return { ...state, lpaAgentDealsIsLoaded: false };

    case ActionTypes.GET_LPA_CLIENT_DEALS[REQUEST]:
      return { ...state, lpaClientDealsIsLoaded: false };
    case ActionTypes.GET_LPA_CLIENT_DEALS[SUCCESS]:
      return {
        ...state,
        lpaClientDealsIsLoaded: true,
        lpaClientDeals: action.data,
      };
    case ActionTypes.GET_LPA_CLIENT_DEALS[FAILURE]:
      return { ...state, lpaClientDealsIsLoaded: false };

    case ActionTypes.GET_LPA_DEAL[REQUEST]:
      return { ...state, lpaDealIsLoaded: false };
    case ActionTypes.GET_LPA_DEAL[SUCCESS]:
      return { ...state, lpaDeal: action.data, lpaDealIsLoaded: true };
    case ActionTypes.GET_LPA_DEAL[FAILURE]:
      return { ...state, error: action.error, lpaDealIsLoaded: false };

    case ActionTypes.GET_EXCHANGE_RATE[REQUEST]:
      return {
        ...state,
        exchangeRateIsLoaded: false,
        exchangeRateError: null,
      };

    case ActionTypes.GET_EXCHANGE_RATE[SUCCESS]:
      return {
        ...state,
        exchangeRate: action.data,
        exchangeRateIsLoaded: true,
        exchangeRateError: null,
      };

    case ActionTypes.GET_EXCHANGE_RATE[FAILURE]:
      return {
        ...state,
        exchangeRateIsLoaded: false,
        exchangeRateError: action.error,
      };

    case ActionTypes.GET_DEPOSIT_REQUISITES_LIST[REQUEST]:
      return {
        ...state,
        depositRequisitesLoaded: false,
      };

    case ActionTypes.GET_DEPOSIT_REQUISITES_LIST[SUCCESS]:
      return {
        ...state,
        depositRequisites: action.data,
        depositRequisitesLoaded: true,
      };

    case ActionTypes.GET_DEPOSIT_REQUISITES_LIST[FAILURE]:
      return {
        ...state,
        depositRequisitesLoaded: false,
      };

    case ActionTypes.GET_WITHDRAW_REQUISITES_LIST[REQUEST]:
      return {
        ...state,
        withdrawRequisitesLoaded: false,
      };

    case ActionTypes.GET_WITHDRAW_REQUISITES_LIST[SUCCESS]:
      return {
        ...state,
        withdrawRequisites: action.data,
        withdrawRequisitesLoaded: true,
      };

    case ActionTypes.GET_WITHDRAW_REQUISITES_LIST[FAILURE]:
      return {
        ...state,
        withdrawRequisitesLoaded: false,
      };

    case ActionTypes.UPDATE_PAYMENT:
      if (state.paymentInfoIsLoaded && state.paymentsInfo.id === action.data.id) {
        return {
          ...state,
          paymentsInfo: {
            ...state.paymentsInfo,
            amountWithCommission: action.data.amountWithCommission,
            cancelButton: action.data.cancelButton,
            paymentProofStatus: action.data.paymentProofStatus,
            comment: action.data.comment,
            amount: action.data.amount,
            commission: action.data.commission,
            events: [
              ...state.paymentsInfo.events,
              { id: action.data.id, status: action.data.status, updated: action.data.updated, newEvent: true },
            ],
          },
        };
      }
      return { ...state, pendingEvents: [...state.pendingEvents, { ...action.data, newEvent: false }] };
    case ActionTypes.REMOVE_PAYMENT_NOTIFICATION:
      if (state.paymentInfoIsLoaded && state.paymentsInfo.id === action.data.id) {
        return {
          ...state,
          paymentsInfo: {
            ...state.paymentsInfo,
            events: [
              ...state.paymentsInfo.events.map(event => {
                if (event.status === action.data.status) {
                  return { ...event, newEvent: false };
                }
                return event;
              }),
            ],
          },
        };
      }
      return state;

    case ActionTypes.getConfirmationForm.REQUEST:
      return {
        ...state,
        confirmationFormIsLoaded: false,
      };
    case ActionTypes.getConfirmationForm.SUCCESS:
      return {
        ...state,
        confirmationForm: action.payload.confirmationForm,
        confirmationFormIsLoaded: true,
      };
    case ActionTypes.getConfirmationForm.FAILURE:
      return {
        ...state,
        confirmationFormIsLoaded: false,
      };
    default:
      return state;
  }
};

export default reducer;
